
import {
  NotificationManager
} from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { useSessionstorageState, useEffectOnceWhen } from 'rooks';

const BraveNotification = () => {
  const [hasShownNotification, setHasShownNotification] = useSessionstorageState('excelsior:shownBraveNotification', false);

  // Function to detect Brave Browser
  const isBraveBrowser = () => {
    const brave = window.navigator.brave;
    return (brave && brave.isBrave) ? brave.isBrave() : Promise.resolve(false);
  };

  useEffectOnceWhen(() => {
    // If notification was already shown, don't show it again
    if (hasShownNotification) return;

    isBraveBrowser().then(isBrave => {
      if (isBrave) {
        NotificationManager.error(
          'You are using Brave Browser which might interfere with the Excelsior! reader. Please go to the Help Center for steps to resolve.',
          'Attention!',
          7000 // 5 seconds duration
        );
        setHasShownNotification(true); // Mark the notification as shown
      }
    });

  }, [hasShownNotification, setHasShownNotification]);

  return null;
};

export default BraveNotification;
